import React, { useState, useEffect } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ language, setLanguage, t }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const toggleLanguage = () => {
    setLanguage(language === 'fr' ? 'en' : 'fr');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <div className="relative h-16 w-16 flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_lodge-website/artifacts/t81s6amh_1000015829.png"
                alt="Outaouais Big Game Logo"
                className="h-16 w-16 object-contain"
              />
            </div>
            <div className="ml-3 hidden sm:block">
              <span className="text-orange-500 font-bold text-xl block">
                Outaouais Big Game
              </span>
              <span className="text-gray-400 text-xs">Permis de pourvoirie 07-919</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {Object.keys(t.nav).map((key) => (
              <button
                key={key}
                onClick={() => scrollToSection(key)}
                className="text-white hover:text-orange-500 transition-colors duration-200 font-medium"
              >
                {t.nav[key]}
              </button>
            ))}
          </nav>

          {/* Language Toggle & Mobile Menu Button */}
          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleLanguage}
              className="text-white hover:text-orange-500 hover:bg-orange-500/10"
            >
              <Globe className="h-4 w-4 mr-2" />
              {language === 'fr' ? 'EN' : 'FR'}
            </Button>

            <button
              className="md:hidden text-white hover:text-orange-500 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md pb-6 space-y-4">
            {Object.keys(t.nav).map((key) => (
              <button
                key={key}
                onClick={() => scrollToSection(key)}
                className="block w-full text-left px-4 py-2 text-white hover:text-orange-500 hover:bg-orange-500/10 transition-colors duration-200 font-medium"
              >
                {t.nav[key]}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};
